import React, { useState } from "react";
import Body from "./components/Body";
import Menu from "./components/Menu";
import MobileMenu from "./components/MobileMenu";

function App() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`lg:grid lg:grid-cols-4 h-screen relative ${isOpen && 'overflow-hidden'}`}>
      <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen} />
      <Menu isOpen={isOpen} setIsOpen={setIsOpen} />
      <Body />
    </div>
  );
}

export default App;
